
const GuestLayout = ({ children }) => {
    return (
        <div>

            <div className="font-sans text-gray-900 antialiased">
                {children}
            </div>
        </div>
    )
}

export default GuestLayout
